import { shape, string } from 'prop-types'
import { ObjectImmobilizer } from '../../models/vehicle/object-immobilizer-model'
import { iso8601PropType } from '../common/iso-8601-prop-type'
import { objectImmobilizerStatePropType } from './object-immobilizer-state-prop-type'

const { REQUESTED_AT, REQUESTER_USER_ID, STATE } = ObjectImmobilizer

/**
 * @readonly
 * @typedef {Object} ObjectImmobilizer
 * @property {ISO8601} [REQUESTED_AT] - ISO time of the last requested state change
 * @property {string} [REQUESTER_USER_ID] - The ID of the user requesting the last state change
 * @property {string} STATE - The state of the immobilizer
 */
export const objectImmobilizerPropType = shape({
    [REQUESTED_AT]: iso8601PropType,
    [REQUESTER_USER_ID]: string,
    [STATE]: objectImmobilizerStatePropType.isRequired
})
